import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { UploaderModule } from '@app/uploader/uploader.module';
import { ReportProblemModalComponent } from './report-problem-modal/report-problem-modal.component';
import { ZendeskWidgetComponent } from './components/zendesk-widget/zendesk-widget.component';
import { DfLabelMarkerModule } from '@lib/fresco';
import { AutofocusDirective } from '@app/shared/directives/autofocus.directive';

@NgModule({
  declarations: [ReportProblemModalComponent, ZendeskWidgetComponent],
  imports: [
    SharedModule,
    UploaderModule,
    DfLabelMarkerModule,

    // standalone components
    AutofocusDirective,
  ],
  exports: [ZendeskWidgetComponent],
  providers: [],
})
export class FeedbackModule {}
